'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dAccount$002dName$0024$0024anon$0024167 from "./presto.types$-Account-Name$$anon$167.js";
var $p;
/** @constructor */
function $c_Lpresto_types$AccountName$() {
  this.c4S = null;
  this.c4T = false;
  this.c4Q = null;
  this.c4R = false;
  this.c4U = null;
  this.c4V = false;
}
export { $c_Lpresto_types$AccountName$ as $c_Lpresto_types$AccountName$ };
$p = $c_Lpresto_types$AccountName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$AccountName$;
/** @constructor */
function $h_Lpresto_types$AccountName$() {
}
export { $h_Lpresto_types$AccountName$ as $h_Lpresto_types$AccountName$ };
$h_Lpresto_types$AccountName$.prototype = $p;
$p.csR = (function() {
  if ((!this.c4T)) {
    this.c4S = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c4T = true;
  }
  return this.c4S;
});
$p.adY = (function() {
  if ((!this.c4R)) {
    this.c4Q = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c4R = true;
  }
  return this.c4Q;
});
$p.cJU = (function() {
  if ((!this.c4V)) {
    this.c4U = new $j_presto$002etypes$0024$002dAccount$002dName$0024$0024anon$0024167.$c_Lpresto_types$AccountName$$anon$167(this);
    this.c4V = true;
  }
  return this.c4U;
});
var $d_Lpresto_types$AccountName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$AccountName$, "presto.types$AccountName$", ({
  YA: 1,
  D: 1
}));
export { $d_Lpresto_types$AccountName$ as $d_Lpresto_types$AccountName$ };
var $n_Lpresto_types$AccountName$;
function $m_Lpresto_types$AccountName$() {
  if ((!$n_Lpresto_types$AccountName$)) {
    $n_Lpresto_types$AccountName$ = new $c_Lpresto_types$AccountName$();
  }
  return $n_Lpresto_types$AccountName$;
}
export { $m_Lpresto_types$AccountName$ as $m_Lpresto_types$AccountName$ };
//# sourceMappingURL=presto.types$-Account-Name$.js.map
